// Auto-managed registry of "10 articles SEO denses" — markdown-driven pages.
// Each markdown body lives in src/content/blog/{slug}.md and is imported as raw text.

import md1 from "@/content/blog/reprendre-le-sport-apres-40-ans-est-lyonnais.md?raw";
import md2 from "@/content/blog/salle-de-sport-avec-coach-est-lyonnais.md?raw";
import md3 from "@/content/blog/crossfit-vs-salle-de-musculation.md?raw";
import md4 from "@/content/blog/debuter-en-crossfit-premiere-seance.md?raw";
import md5 from "@/content/blog/preparation-hyrox-lyon-est-programme-12-semaines.md?raw";
import md6 from "@/content/blog/sport-en-famille-saint-pierre-de-chandieu.md?raw";
import md7 from "@/content/blog/salle-de-sport-associative-ou-box-crossfit.md?raw";
import md8 from "@/content/blog/box-crossfit-proche-mions-saint-priest-genas.md?raw";
import md9 from "@/content/blog/open-crossfit-2027-preparer-27-1-27-2-27-3.md?raw";
import md10 from "@/content/blog/musculation-douce-apres-40-ans.md?raw";

import type { BlogCluster } from "@/data/blog-articles";

export interface ExtraArticle {
  slug: string;
  title: string;
  description: string;
  h1: string;
  publishedAt: string;
  readingMinutes: number;
  cluster: BlogCluster;
  ctaVariant: "default" | "douleur" | "reprise" | "competition" | "debutant";
  needsHealthDisclaimer: boolean;
  category: string;
  breadcrumbLabel: string;
  excerpt: string;
  author: { name: string; role: string };
  reviewer?: { name: string; role: string };
  body: string;
}

export const EXTRA_ARTICLES: ExtraArticle[] = [
  {
    slug: "reprendre-le-sport-apres-40-ans-est-lyonnais",
    title: "Reprendre le sport après 40 ans dans l'Est lyonnais : par où commencer",
    description: "Reprendre le sport après 40 ans à Saint-Priest, Mions, Genas, Chaponnay : la méthode honnête, sans douleur ni rechute. Box CrossFit Chistera.",
    h1: "Reprendre le sport après 40 ans dans l'Est lyonnais : par où commencer vraiment",
    publishedAt: "2026-05-20", readingMinutes: 9,
    cluster: "reprise", ctaVariant: "reprise", needsHealthDisclaimer: true,
    category: "Reprise · 40+ ans", breadcrumbLabel: "Reprendre après 40 ans",
    excerpt: "La méthode honnête sans douleur ni rechute pour les cadres actifs de l'Est lyonnais.",
    author: { name: "Cédric Bastien & Anthony Bendahmane", role: "Responsables de la publication – CrossFit Chistera" },
    reviewer: { name: "Anthony Bendahmane (Benbou)", role: "Master STAPS, CrossFit Level 1" },
    body: md1,
  },
  {
    slug: "salle-de-sport-avec-coach-est-lyonnais",
    title: "Salle de sport avec coach dans l'Est lyonnais : ce que ça change vraiment",
    description: "Salle de sport avec coach à Saint-Priest, Mions, Genas, Chaponnay : ce que coach diplômé change concrètement vs salle libre-service. Box CrossFit Chistera.",
    h1: "Salle de sport avec coach dans l'Est lyonnais : ce que ça change vraiment",
    publishedAt: "2026-05-22", readingMinutes: 8,
    cluster: "methode", ctaVariant: "default", needsHealthDisclaimer: false,
    category: "Méthode · Coaching", breadcrumbLabel: "Salle avec coach",
    excerpt: "Pourquoi un vrai encadrement change tout : technique, progression, rétention.",
    author: { name: "Cédric Bastien & Anthony Bendahmane", role: "Responsables de la publication – CrossFit Chistera" },
    reviewer: { name: "Cédric Bastien", role: "BPJEPS AGFF, CrossFit Level 1, coach gérant" },
    body: md2,
  },
  {
    slug: "crossfit-vs-salle-de-musculation",
    title: "CrossFit vs salle de musculation : 7 différences pour vraiment choisir",
    description: "CrossFit ou salle de musculation classique : forces, faiblesses, profil idéal. Comparatif honnête par CrossFit Chistera, box affiliée Saint-Pierre-de-Chandieu.",
    h1: "CrossFit vs salle de musculation : 7 différences pour vraiment progresser",
    publishedAt: "2026-05-24", readingMinutes: 9,
    cluster: "methode", ctaVariant: "default", needsHealthDisclaimer: false,
    category: "Méthode · Comparatif", breadcrumbLabel: "CrossFit vs musculation",
    excerpt: "7 différences concrètes pour choisir selon votre profil et vos objectifs.",
    author: { name: "Cédric Bastien & Anthony Bendahmane", role: "Responsables de la publication – CrossFit Chistera" },
    reviewer: { name: "Anthony Bendahmane (Benbou)", role: "Master STAPS, spécialiste haltérophilie" },
    body: md3,
  },
  {
    slug: "debuter-en-crossfit-premiere-seance",
    title: "Débuter en CrossFit : ce que personne ne dit avant la première séance",
    description: "Première séance de CrossFit à Saint-Pierre-de-Chandieu : à quoi s'attendre, tenue, niveau requis, peurs classiques. Honest guide par CrossFit Chistera.",
    h1: "Débuter en CrossFit : ce que personne ne vous dit avant la première séance",
    publishedAt: "2026-05-27", readingMinutes: 8,
    cluster: "decouverte", ctaVariant: "debutant", needsHealthDisclaimer: false,
    category: "Découverte · Débutant", breadcrumbLabel: "Première séance",
    excerpt: "Tenue, niveau, déroulé et peurs classiques avant le premier WOD.",
    author: { name: "Cédric Bastien & Anthony Bendahmane", role: "Responsables de la publication – CrossFit Chistera" },
    reviewer: { name: "Perrine", role: "BPJEPS AGFF, CrossFit Level 1" },
    body: md4,
  },
  {
    slug: "preparation-hyrox-lyon-est-programme-12-semaines",
    title: "Préparation Hyrox dans l'Est lyonnais : programme 12 semaines",
    description: "Préparer un Hyrox à Lyon Est en 12 semaines : structure programme, mouvements clés, charges, erreurs. Box CrossFit Chistera, à 15 min d'Eurexpo.",
    h1: "Préparation Hyrox dans l'Est lyonnais : programme 12 semaines qui fonctionne",
    publishedAt: "2026-05-30", readingMinutes: 10,
    cluster: "competition", ctaVariant: "competition", needsHealthDisclaimer: false,
    category: "Compétition · Hyrox", breadcrumbLabel: "Préparation Hyrox 12 semaines",
    excerpt: "Plan 12 semaines, mouvements clés, erreurs à éviter pour un premier Hyrox.",
    author: { name: "Cédric Bastien & Anthony Bendahmane", role: "Responsables de la publication – CrossFit Chistera" },
    reviewer: { name: "Cédric Bastien", role: "BPJEPS AGFF, spécialiste cardio/endurance" },
    body: md5,
  },
  {
    slug: "sport-en-famille-saint-pierre-de-chandieu",
    title: "Sport en famille à Saint-Pierre-de-Chandieu : trouver l'équilibre",
    description: "Sport en famille à Saint-Pierre-de-Chandieu, Mions, Genas : CrossFit Kids, cours parents-enfants, Family Contest. Box Chistera.",
    h1: "Sport en famille à Saint-Pierre-de-Chandieu : trouver l'équilibre parents-enfants",
    publishedAt: "2026-06-03", readingMinutes: 8,
    cluster: "profils", ctaVariant: "default", needsHealthDisclaimer: false,
    category: "Profils · Famille", breadcrumbLabel: "Sport en famille",
    excerpt: "CrossFit Kids, cours parents-enfants : comment caler le sport en famille.",
    author: { name: "Cédric Bastien & Anthony Bendahmane", role: "Responsables de la publication – CrossFit Chistera" },
    reviewer: { name: "Perrine", role: "BPJEPS AGFF, coach Kids" },
    body: md6,
  },
  {
    slug: "salle-de-sport-associative-ou-box-crossfit",
    title: "Salle de sport associative ou box CrossFit : que choisir vraiment",
    description: "Salle de sport associative ou box CrossFit affiliée : tarifs, coaching, méthode, communauté. Comparatif honnête dans l'Est lyonnais par CrossFit Chistera.",
    h1: "Salle de sport associative ou box CrossFit affiliée : que choisir vraiment",
    publishedAt: "2026-06-05", readingMinutes: 8,
    cluster: "methode", ctaVariant: "default", needsHealthDisclaimer: false,
    category: "Méthode · Comparatif", breadcrumbLabel: "Associatif vs box",
    excerpt: "Tarifs, coaching, méthode, communauté : comparatif honnête dans l'Est lyonnais.",
    author: { name: "Cédric Bastien & Anthony Bendahmane", role: "Responsables de la publication – CrossFit Chistera" },
    reviewer: { name: "Cédric Bastien", role: "BPJEPS AGFF, coach gérant" },
    body: md7,
  },
  {
    slug: "box-crossfit-proche-mions-saint-priest-genas",
    title: "Box CrossFit proche de Mions, Saint-Priest, Genas : panorama Est lyonnais",
    description: "Box CrossFit affiliée près de Mions, Saint-Priest, Genas, Chaponnay : panorama des options dans l'Est lyonnais. Distances, tarifs, spécialités. Box Chistera.",
    h1: "Box CrossFit proche de Mions, Saint-Priest, Genas : panorama de l'Est lyonnais",
    publishedAt: "2026-06-10", readingMinutes: 9,
    cluster: "lieu", ctaVariant: "default", needsHealthDisclaimer: false,
    category: "Près de chez vous", breadcrumbLabel: "Box Est lyonnais",
    excerpt: "Distances, tarifs, spécialités : panorama des box affiliées de l'Est lyonnais.",
    author: { name: "Cédric Bastien & Anthony Bendahmane", role: "Responsables de la publication – CrossFit Chistera" },
    reviewer: { name: "Cédric Bastien", role: "BPJEPS AGFF, coach gérant" },
    body: md8,
  },
  {
    slug: "open-crossfit-2027-preparer-27-1-27-2-27-3",
    title: "Open CrossFit 2027 : préparer 27.1, 27.2 et 27.3 sans erreur",
    description: "Open CrossFit 2027 : format, inscription, préparation 27.1, 27.2, 27.3. Le guide complet par CrossFit Chistera, box affiliée à Saint-Pierre-de-Chandieu.",
    h1: "Open CrossFit 2027 : tout comprendre et bien préparer 27.1, 27.2, 27.3",
    publishedAt: "2027-01-20", readingMinutes: 11,
    cluster: "competition", ctaVariant: "competition", needsHealthDisclaimer: false,
    category: "Compétition · Open", breadcrumbLabel: "Open CrossFit 2027",
    excerpt: "Format, inscription, préparation séance par séance pour ne pas griller l'Open.",
    author: { name: "Cédric Bastien & Anthony Bendahmane", role: "Responsables de la publication – CrossFit Chistera" },
    reviewer: { name: "Anthony Bendahmane (Benbou)", role: "Master STAPS, 8 ans de compétition CrossFit" },
    body: md9,
  },
  {
    slug: "musculation-douce-apres-40-ans",
    title: "Musculation douce après 40 ans : la fausse bonne idée",
    description: "Musculation douce après 40 ans : pourquoi ça ne renforce pas vraiment, et ce qui marche pour reprendre sans se blesser. CrossFit Chistera.",
    h1: "Musculation douce après 40 ans : la fausse bonne idée et ce qui marche",
    publishedAt: "2026-06-12", readingMinutes: 9,
    cluster: "reprise", ctaVariant: "reprise", needsHealthDisclaimer: true,
    category: "Reprise · 40+ ans", breadcrumbLabel: "Musculation douce 40+",
    excerpt: "Pourquoi la « muscu douce » ne renforce pas vraiment, et ce qui marche après 40 ans.",
    author: { name: "Cédric Bastien & Anthony Bendahmane", role: "Responsables de la publication – CrossFit Chistera" },
    reviewer: { name: "Orni", role: "Double BPJEPS APT/AF, formation préparation mentale" },
    body: md10,
  },
];

export const EXTRA_BY_SLUG: Record<string, ExtraArticle> = Object.fromEntries(
  EXTRA_ARTICLES.map((a) => [a.slug, a])
);
